// import Vue from 'vue';
import DictHelper from './dictHelper';
export default {
  install(Vue, options = {}) {
    Vue.use(DictHelper);
  }
};
